var DEV = false;
export const BACKEND_HOST_DEV0 = "http://127.0.0.1:8000/api"; // 'http://127.0.0.1:8000' // 'http://192.168.1.102:8000'
export const BACKEND_HOST_DEV1 = "http://82.130.102.199:8000/api"; // 'http://127.0.0.1:8000' // 'http://192.168.1.102:8000'
export const BACKEND_HOST_PROD = "https://confsearch.ethz.ch/api"; // 'http://192.168.1.102:8000'
export const BACKEND_HOST = DEV ? BACKEND_HOST_DEV1 : BACKEND_HOST_PROD;

export const CSRF_URL = BACKEND_HOST + "/csrf-token";
